// This page implements the original (V1) Unbox safety flow. A newer version
// now exists — see packages/frontend/src/pages/safety-beta.
import { useNavigate, useSearch } from "@tanstack/react-router";
import { AlertTriangle, ClockRewind, Shield01 } from "@untitledui/icons";
import { Tabs } from "@/components/application/tabs/tabs";
import type { legacyRisksToReviewRoute } from "@/router";
import { LAYOUT_CONSTRAINTS } from "@/utils/layout-constants";
import { SafetyVideosTable } from "./table";

const tabs = [
  { id: "pendingManualReview" as const, label: "Pending Manual Review", icon: <AlertTriangle className="w-4 h-4" /> },
  { id: "manuallyReviewed" as const, label: "Manually Reviewed", icon: <ClockRewind className="w-4 h-4" /> },
];

export const RisksToReview = () => {
  const urlParams = useSearch({ strict: false }) as ReturnType<(typeof legacyRisksToReviewRoute)["useSearch"]>;
  const { tab, video_id } = urlParams;
  const navigate = useNavigate() as ReturnType<(typeof legacyRisksToReviewRoute)["useNavigate"]>;

  return (
    <div className="flex flex-col w-full h-screen items-center">
      <div className={`${LAYOUT_CONSTRAINTS.CONTAINER_WIDTH} flex flex-col gap-5 h-full px-16 pt-16 pb-8`}>
        <div className="w-full h-full flex flex-row">
          <SafetyVideosTable
            category={tab}
            initialVideoId={video_id}
            onVideoIdChange={(videoId) => navigate({ search: (prev) => ({ ...prev, video_id: videoId }) })}
            navigate={navigate}
            currentSearch={urlParams}
            title={
              <div className="flex flex-col">
                <h1 className="text-xl font-normal text-primary flex flex-row items-center gap-2 mb-1">
                  <Shield01 className="text-xl" strokeWidth={1.8} />
                  Videos with Risks
                </h1>
                <span className="text-quaternary text-sm">
                  Review videos with risks identified and decide next steps
                </span>
              </div>
            }
            tabs={
              <Tabs
                selectedKey={tab}
                onSelectionChange={(key) =>
                  navigate({ search: { tab: key as "pendingManualReview" | "manuallyReviewed" } })
                }
                className="w-max max-md:hidden shrink-0"
              >
                <Tabs.List type="underline" items={tabs}>
                  {(tab) => <Tabs.Item {...tab} />}
                </Tabs.List>
              </Tabs>
            }
          />
        </div>
      </div>
    </div>
  );
};
